import React from 'react';
import Container from '../Container/Container';
import styles from './Separator.scss';

function Separator(props) {
  return /*#__PURE__*/React.createElement(Container, props, /*#__PURE__*/React.createElement("hr", {
    className: styles.separator
  }));
}

Separator.defaultProps = {
  marginTop: 4,
  marginBottom: 4
};
export default Separator;